export function getGroupId(
  accountCode, debit, credit
) {
  let suffix = "";
  if (debit === 0 && credit === 0) {
    suffix = "Z";
  } else if (debit > 0) {
    suffix = "D";
  } else {
    suffix = "C";
  }
  return accountCode?.replaceAll("/", "-") + "-" + suffix;
}

export function onResizeWidthChange(contoId) {
  let elmnt = document.querySelector(`.ts-vapor-tableComplex-row.row_${contoId}`);
  if (elmnt) {
    for (let i = 0; i < elmnt.children.length; i++) {
      let targets = document.querySelectorAll(".ddcontainersource #articles-accordion_" +
            contoId +
            " .articles-accordion-col.col-" +
          (i + 1));
      if (targets) {
        Array.from(targets).map(target => target.style.width =
            elmnt.children[i].getBoundingClientRect().width + "px");
      }
    }
  }
  let elmntGhost = document.querySelector(".ddcontainersource #articles-accordion_" + contoId);
  if (elmntGhost) {
    let targetGhost = document.querySelector("#articles_ddcontainer" + contoId + " .ddcontainerghost");
    if (targetGhost) {
      targetGhost.style.width =
          elmntGhost.getBoundingClientRect().width + "px";
    }
  }
}

export function clearResizeWidth(contoId, colsWidth) {  
  let elmnt = document.querySelector(`.ts-vapor-tableComplex-row.row_${contoId}`);
  if (elmnt) {
    for (let i = 0; i < elmnt.children.length; i++) {
      let targets = document.querySelectorAll(".ddcontainersource #articles-accordion_" +
            contoId +
            " .articles-accordion-col.col-" +
            (i + 1));
      if (targets) {
        Array.from(targets).map(target => target.style.width = colsWidth[i]);
      }
    }
  }
}

export function getVatRatesType(selectedArticles, articles) {
  let rateType = "";
  if (selectedArticles) {
    let isAllZero = true;
    let isAllStandard = true;
    selectedArticles.map(el => {
      const currentArticle = articles.find(article => article.uuid === el);
      if (currentArticle.vatRate === "0.0") {
        isAllStandard = false;
      } else {
        isAllZero = false;
      }
    });
    if (isAllZero === true) {
      rateType = "zero";
    } else if (isAllStandard === true) {
      rateType = "standard";
    } else {
      rateType = "mix";
    }
  }
  return rateType;
}
